import { render } from "./Prognostic.vue?vue&type=template&id=8d97a0a0&scoped=true"
import script from "./Prognostic.vue?vue&type=script&lang=js"
export * from "./Prognostic.vue?vue&type=script&lang=js"

import "./Prognostic.vue?vue&type=style&index=0&id=8d97a0a0&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d97a0a0"]])

export default __exports__